export const PROJECT_SUMMARY_COLUMNS: {
  title: string
  width: number
}[] = [
  {
    // The expand/collapse chevron. No header label.
    title: '',
    width: 5,
  },
  {
    title: 'Name',
    width: 29,
  },
  {
    title: 'Size',
    width: 10,
  },
  {
    title: 'Utility',
    width: 18,
  },
  {
    title: 'Array Location',
    width: 12,
  },
  {
    title: 'Phase',
    width: 12,
  },
  {
    title: 'Contract Type',
    width: 14,
  },
]
